import {UNKNOWN_API_ERROR} from "./error";

export class ApiError extends Error {
  constructor(
    public message: string | any = UNKNOWN_API_ERROR,
    public status: number | undefined = undefined
  ) {
    super(message);
    // fixes the custom error type issue
    // to read more: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
